import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarColor'
})
export class AvatarColorPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const type = args[0] as ('background' | 'text');
    const colors = [
      [159, 0, 0],
      [159, 82, 0],
      [159, 112, 0],
      [50, 159, 0],
      [50, 159, 144],
      [0, 114, 159],
      [0, 47, 159],
      [94, 0, 159],
      [159, 0, 149],
    ];
    let color = null;
    const chatAvatarColorsJSON = localStorage.getItem('chatAvatarColors');
    let chatAvatarColors = {};
    if (chatAvatarColorsJSON) {
      chatAvatarColors = JSON.parse(chatAvatarColorsJSON);
      color = chatAvatarColors[value];
    }
    if (!color) {
      color = colors[Math.floor(Math.random() * colors.length)];
      chatAvatarColors[value] = color;
      localStorage.setItem('chatAvatarColors', JSON.stringify(chatAvatarColors));
    }
    if (type === 'background') {
      return `rgba(${color[0]}, ${color[1]}, ${color[2]}, 0.3)`;
    }
    if (type === 'text') {
      return `rgba(${color[0]}, ${color[1]}, ${color[2]}, 1)`;
    }
  }

}
